import(/* webpackMode: "eager" */ "/app/apps/ashtrom-construction/app/[locale]/not-found.tsx");
